import React from "react";
import BasicInformationContainer from "../../../containers/Payroll/BasicInformationContainer";

const BasicInformation = (props) => {
  return <BasicInformationContainer {...props} />;
};

export default BasicInformation;
